import { DietaryCategory as ApiDietaryCategory, DietaryAttributeStatus, AllergenSource } from '../recipeV2/recipeV2Types';

/** The demo registry also tracks sourcing claims, which are absent from the Recipe API. */
export const DietaryCategory = { ...ApiDietaryCategory, SourcingSustainability: 'SourcingSustainability' } as const;
export type DietaryCategory = typeof DietaryCategory[keyof typeof DietaryCategory];

/** Types for the Range Planning "Attributes & Allergens" demo screen - a central governance
 * registry for every allergen/dietary attribute code used across Recipes and Items, with
 * traceability (where is this attribute used?) and conflict detection (does an entity claim
 * two mutually exclusive attributes?). Demo-only - no real backend exists for this concept
 * yet. */

export enum AttributeGovernanceStatus {
  Active = 'Active',
  UnderReview = 'UnderReview',
  Deprecated = 'Deprecated',
}

export interface MasterAttribute {
  id: number;
  code: string;
  name: string;
  category: DietaryCategory;
  isRegulatory: boolean;
  governanceStatus: AttributeGovernanceStatus;
  description: string;
}

export type AttributeUsageEntityType = 'Recipe' | 'Item' | 'Menu';

export interface AttributeUsageEntry {
  entityType: AttributeUsageEntityType;
  entityId: number;
  entityName: string;
  status: DietaryAttributeStatus;
  source: AllergenSource;
}

export type ConflictSeverity = 'High' | 'Medium' | 'Low';

export interface AttributeConflict {
  id: string;
  entityType: AttributeUsageEntityType;
  entityId: number;
  entityName: string;
  attributeCode: string;
  conflictingAttributeCode: string;
  description: string;
  severity: ConflictSeverity;
}

export interface AttributeListResponse {
  data: MasterAttribute[];
  totalCount: number;
}
